import { Box, Paper } from "@mui/material";
import React from "react";
import SideBar from "./SideBar";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

const LayoutWrapper = ({ children }) => {
  const isAuthenticated = useSelector((state) => !!state.auth.token); // Check if token exists in Redux
  // let isAuthenticated = true;
  const theme = useTheme();

  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/login" replace />;
  }


  console.log({ theme });

  return (
    <Box display={"flex"} height={"100vh"} overflow={"hidden"}>
      <SideBar />
      <Box
        component={Paper}
        flex={1}
        px={3}
        py={2}
        sx={{
          overflowX: "auto",
          borderRadius: 0,
          background:
            "linear-gradient(to bottom,rgba(255, 213, 0, 0.09) 0%,rgba(255, 255, 255, 0) 20%)",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default LayoutWrapper;
